import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LaravelResourceResponse } from '../../../../../_base-shared/contracts/laravel-response.interface';
import { User } from '../../../../../_base-shared/models/User/User';
import { MainGlobalEventService } from '../../_shared/services/main-global-event.service';
import { UserService } from '../../admin/user/user.service';
import { AuthService } from '../../auth/auth.service';
import { ClientService } from '../../client/client.service';

@Component({
  selector:    'app-header',
  templateUrl: './header.component.html',
  styleUrls:   ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() notifications;
  public authUser: User;

  constructor(private router: Router,
              private cookieService: CookieService,
              private translate: TranslateService,
              private toastr: ToastrService,
              private globalEventsService: MainGlobalEventService,
              private authService: AuthService,
              private userService: UserService,
              private clientService: ClientService) {
  }

  ngOnInit(): void {
    this.globalEventsService.authUser$.subscribe(user => this.authUser = user);
  }

  public logout() {
    this.authService.logout().subscribe(res => {
      this.globalEventsService.setAuthUser(null);
      this.router.navigateByUrl('/login');
    });
  }

  public changeLanguage($event, language: 'en' | 'es') {
    $event.preventDefault();
    this.translate.use(language);
    this.cookieService.set('lang', language, 365, '/');
    if (this.authUser) {
      let subscription: Observable<LaravelResourceResponse>;
      if (this.authUser.role.name === 'User') {
        subscription = this.clientService.updateUser(this.authUser.uuid, {locale: language});
      } else {
        subscription = this.userService.update(this.authUser.id, {locale: language});
      }
      subscription.subscribe(result => {
        const message = language === 'en' ? 'Language changed to english' : 'Idioma cambiado a español';
        this.toastr.success(message);
      });
    }
  }
}
